import { createSelector } from '@reduxjs/toolkit';
import { selfClientSelector } from './self';

const clientSelector = createSelector(selfClientSelector, (clients) => clients.client);

export default clientSelector;
